import type { ReactNode } from "react";
import { useIdioma } from "../../i18n/IdiomaProvider";
import { BotaoFechar } from "./BotaoFechar";
import styles from "./CascaModal.module.css";

interface CabecalhoModalProps {
  icone?: ReactNode;
  titulo: string;
  subtitulo?: string;
  onFechar: () => void;
  progresso?: ReactNode;
  className?: string;
}

export function CabecalhoModal({ icone, titulo, subtitulo, onFechar, progresso, className }: CabecalhoModalProps) {
  const { traduzir } = useIdioma();
  return (
    <header className={[styles.cabecalho, className].filter(Boolean).join(" ")}>
      <div className={styles.identidade}>
        {icone && <span className={styles.icone} aria-hidden="true">{icone}</span>}
        <div className={styles.textos}>
          <h2 className={styles.titulo}>{traduzir(titulo)}</h2>
          {subtitulo && <p className={styles.subtitulo}>{traduzir(subtitulo)}</p>}
        </div>
      </div>
      {progresso}
      <BotaoFechar onClick={onFechar} />
    </header>
  );
}

interface RodapeModalProps {
  children: ReactNode;
  aviso?: ReactNode;
  className?: string;
}

export function RodapeModal({ children, className }: RodapeModalProps) {
  return (
    <footer className={[styles.rodape, className].filter(Boolean).join(" ")}>
      <div className={styles.acoes}>{children}</div>
    </footer>
  );
}
